import { ComponentConfig } from "@measured/puck";
import {
  CheckList as CheckListComponent,
  CheckListProps as CheckListComponentProps,
} from "@kunduz/feature-landing-pages";
import {
  defaultComponentOrdering,
  defaultComponentOrderingFields,
  defaultComponentSize,
  defaultComponentSizeFields,
} from "../../utils";

export interface CheckListProps extends CheckListComponentProps {}

const CheckList = (props: CheckListProps) => {
  return <CheckListComponent {...props} />;
};

export const PuckCheckList: ComponentConfig<CheckListProps> = {
  label: "Check List",
  fields: {
    list: {
      type: "array",
      label: "List Items",
      arrayFields: {
        text: { type: "text", label: "Text" },
      },
    },
    options: {
      type: "object",
      label: "Options",
      objectFields: {
        ...(defaultComponentSizeFields as any),
        ...(defaultComponentOrderingFields as any),
      },
    },
  },
  defaultProps: {
    list: [{ text: "Item 1" }, { text: "Item 2" }, { text: "Item 3" }],
    options: {
      ...defaultComponentSize,
      ...defaultComponentOrdering,
    },
  },
  render: (props) => <CheckList {...props} />,
};
